/**
 * Контракт виджета: что обязан уметь рендерер слоя.
 *
 * Три метода вместо одного `render(props)` — не усложнение, а прямое
 * следствие того, где это работает. Оверлей живёт в OBS часами
 * и перерисовывается шестьдесят раз в секунду; пересоздание узла
 * на каждое изменение означает, что видео начинает играть сначала,
 * анимация дёргается, а картинка моргает белым, пока грузится заново.
 * Поэтому создание, изменение и уничтожение разделены явно.
 */
/** Негодные свойства слоя. */
export class WidgetPropsError extends Error {
    widget;
    field;
    constructor(widget, field, message) {
        super(`${widget}: ${field} — ${message}`);
        this.widget = widget;
        this.field = field;
        this.name = 'WidgetPropsError';
    }
}
/**
 * Пересекается ли слой с кадром хотя бы частично.
 *
 * ИМЕННО ПЕРЕСЕКАЕТСЯ, а не «лежит внутри целиком». Разница
 * существенная: выезд картинки из-за края — законный приём, и при
 * проверке «внутри целиком» он бы сломался. Слой был бы не создан,
 * пока не въедет полностью, то есть зритель увидел бы, как он
 * появляется из ниоткуда посреди экрана вместо плавного выезда.
 *
 * Касание краем считается пересечением: слой шириной в ноль
 * у самой границы всё ещё виден как линия.
 */
export function intersectsFrame(rect, frameW, frameH) {
    if (!isFinite(rect.x) || !isFinite(rect.y) || !isFinite(rect.w) || !isFinite(rect.h)) {
        return false;
    }
    return rect.x <= frameW && rect.x + rect.w >= 0 && rect.y <= frameH && rect.y + rect.h >= 0;
}
function isFinite(v) {
    return Number.isFinite(v);
}
//# sourceMappingURL=contract.js.map